import { render, staticRenderFns } from "./soAllocationEdit.vue?vue&type=template&id=53ff36aa&"
import script from "./soAllocationEdit.vue?vue&type=script&lang=js&"
export * from "./soAllocationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports